import React from "react";
import {
  Grid,
  TextField,
  Box,
  Divider,
  Chip,
  Fab,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Checkbox,
  FormHelperText,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchField from "react-search-field";
import { Alert, AlertTitle } from "@mui/material";

export default function Programming(props) {
  let { OSTYPE, appsetFormFields, appfieldIndex } = props;
  const [customlang, setCustomlang] = React.useState([[]]);
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState({});
  const [forversion, setForversion] = React.useState({});
  const [selectedVersions, setSelectedVersions] = React.useState({});
  const [apperror, setApperror] = React.useState(false);
  const [searchitems, setSearchItems] = React.useState("");

  const handleClickOpen = (e) => {
    setOpen(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/svmlanglist/${OSTYPE}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setCustomlang(resp))
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
    setSelectedValue({});
    setForversion({});
    setSelectedVersions({});
  };

  const handleChange = (e, index, ports) => {
    const { value, checked } = e.target;

    setSelectedValue((prevState) => ({
      ...prevState,
      [value]: checked,
    }));

    if (checked) {
      const apipostval = value + "-" + OSTYPE;
      fetch(
        `${process.env.REACT_APP_API_URL}/api/svmlangversionlist/${apipostval}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((resp) => resp.json())
        .then((resp) =>
          setForversion((prevState) => ({
            ...prevState,
            [index]: resp,
          }))
        )
        .catch((error) => {
          console.error(error);
        });
    } else {
      setForversion((prevState) => ({
        ...prevState,
        [index]: "",
      }));
      setSelectedVersions((prevState) => ({
        ...prevState,
        [value]: "",
      }));
    }
  };

  const handleChangeInput = (e, index, appname) => {
    const { value } = e.target;
    setSelectedVersions((prevState) => ({
      ...prevState,
      [appname]: value,
    }));
  };

  const handleSumbitClick = (e) => {
    let assignAppValue = [];
    let count = 0;
    customlang.forEach((appdata) => {
      if (selectedValue[appdata.Name]) {
        if (selectedVersions[appdata.Name]) {
          const appval = `${appdata.Name}-${selectedVersions[appdata.Name]}`;
          assignAppValue.push(appval);
        } else {
          count += 1;
        }
      }
    });
    if (count > 0) {
      setApperror(true);
    } else {
      setApperror(false);
      appsetFormFields((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppValue,
      }));
      setOpen(false);
    }
  };

  return (
    <>
      <div>
        <Fab 
          variant="extended" 
          size="small" 
          color="primary" 
          aria-label="add"
          sx={{ borderRadius: '16px' }}
        >
          <Chip
            icon={<AddIcon />}
            label="Programming languages"
            clickable
            color="primary"
            onClick={handleClickOpen}
          />
        </Fab>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          Programming languages{" "}
        </DialogTitle>
        {apperror && (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Please make sure all the fields are selected.
          </Alert>
        )}
        <DialogContent dividers>
          <SearchField
            value={searchitems}
            placeholder="Search..."
            onChange={(value) => {
              setSearchItems(value);
            }}
            classNames="test-class"
          />
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <Box>
              {customlang.length > 0 && (
                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <Grid container spacing={0} sx={{ mt: 3 }}>
                      <Grid item xs={8}>
                        <Typography variant="h8" gutterBottom>
                          Languages
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="h8" gutterBottom>
                          Version
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider />
                    {customlang
                      .filter((val) => {
                        if (searchitems === "") {
                          return true;
                        }
                        return val.Title.toLowerCase().includes(
                          searchitems.toLowerCase()
                        );
                      })
                      .map((e, index) => {
                        let ports = e.Ports;
                        let appname = e.Name;
                        return (
                          <Grid container spacing={0} sx={{ mt: 3 }} key={index}>
                            <Grid item xs={8}>
                              <Checkbox
                                checked={selectedValue[e.Name] || false}
                                onChange={(e) => handleChange(e, index, ports)}
                                value={e.Name}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                              />
                              <Typography variant="h8" gutterBottom>
                                {e.Title}
                              </Typography>
                              <FormHelperText sx={{ ml: 5 }}>
                                min req: {e.requirements}
                              </FormHelperText>
                            </Grid>
                            <Grid item xs={2}>
                              <TextField
                                fullWidth
                                name="version"
                                id="version"
                                onChange={(e) => handleChangeInput(e, index, appname)}
                                required
                                select
                                SelectProps={{ native: true }}
                                autoComplete="name"
                                value={selectedVersions[appname] || ""}
                              >
                                <option value="">--Select the Version--</option>
                                {forversion[index] &&
                                  forversion[index].split(",").map((appdata, idx) => (
                                    <option value={appdata} key={idx}>
                                      {appdata}
                                    </option>
                                  ))}
                              </TextField>
                            </Grid>
                          </Grid>
                        );
                      })}
                  </Grid>
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        fontStyle: "italic",
                        height: "100%",
                        backgroundColor: "whitesmoke",
                      }}
                      borderColor="error.main"
                      border={1}
                    >
                      <strong>Chosen Programming Languages :</strong>
                      {customlang.map((e, index) => {
                        if (
                          selectedValue[e.Name] &&
                          !selectedVersions[e.Name]
                        ) {
                          return (
                            <li
                              style={{ textAlignLast: "center" }}
                              key={index}
                            >{`${e.Name}-<Version>`}</li>
                          );
                        } else if (
                          selectedValue[e.Name] &&
                          selectedVersions[e.Name]
                        ) {
                          return (
                            <li style={{ textAlignLast: "center" }} key={index}>
                              {`${e.Name}-${selectedVersions[e.Name]}`}
                            </li>
                          );
                        }
                        return null;
                      })}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog without saving">
            <Button onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
              Close
            </Button>
          </Tooltip>
          <Tooltip title="Cancel and discard changes">
            <Button onClick={handleCancel} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Save changes">
            <Button onClick={handleSumbitClick} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
              Save
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
}
